var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('license-write-component',{attrs:{"license-type":'licensePay',"license-key":_vm.licenseKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }